import Course from "./course"

export class QScoreHistory {
  readonly qId: number
  readonly userExamId: number
  readonly score: number
  readonly qMaxScore: number
  readonly createdAt: Date
  readonly examType: number

  constructor(data: { [key: string]: any }) {
    this.qId = data.qId
    this.userExamId = data.userExamId
    this.score = data.score
    this.qMaxScore = data.qMaxScore
    this.createdAt = new Date(data.createdAt)
    this.examType = data.examType 
  }
}

export class ExamQScoreHistory {
  readonly examId: number
  readonly examName: string
  readonly qScoreHistories: QScoreHistory[]

  constructor(data: { [key: string]: any }) {
    this.examId = data.exam.id
    this.examName = data.exam.name
    this.qScoreHistories = data.list.map(item => new QScoreHistory(item))
  }

  getQScoreHistorySummary(qId: number) {
    const histories = this.qScoreHistories.filter(item => item.qId == qId)

    if (histories.length == 0) {
      return null
    }
    const successHistories = histories.filter(item=>item.score > 0)

    return {
      totalCount: histories.length,
      successCount: successHistories.length,
      rate: Math.round((successHistories.length / histories.length) * 100),
      histories
    }
  }
}